import { render, staticRenderFns } from "./PaymentType.vue?vue&type=template&id=14fafe5c"
import script from "./PaymentType.vue?vue&type=script&lang=js"
export * from "./PaymentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports